import { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
  PieChart, Pie, Cell, Legend,
} from "recharts";

const STATUS_COLOR = {
  "Completed": "#10B981",
  "In Progress": "#00D4FF",
  "Production Repair": "#F59E0B",
  "New NCR": "#EF4444",
  "On Hold": "#94A3B8",
};

export default function Insights() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/insights").then((r) => setD(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="insights-page">
      <header>
        <div className="text-[11px] tracking-[0.35em] uppercase text-[#00D4FF]">09 · Insights</div>
        <h1 className="font-heading font-bold text-4xl tracking-tight mt-2">Production Insights</h1>
      </header>

      <section className="bg-[#12141D] border border-border p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading font-semibold">14-Day Output Timeline</h2>
          <span className="text-[10px] uppercase tracking-widest text-muted-foreground">Hours · Square feet</span>
        </div>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
            <AreaChart data={d?.timeline || []}>
              <defs>
                <linearGradient id="cyanFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#00D4FF" stopOpacity={0.35} />
                  <stop offset="95%" stopColor="#00D4FF" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="tealFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#00BFA5" stopOpacity={0.25} />
                  <stop offset="95%" stopColor="#00BFA5" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="#1E293B" vertical={false} />
              <XAxis dataKey="date" stroke="#94A3B8" tick={{ fill: "#94A3B8", fontSize: 10 }} tickFormatter={(v) => v.slice(5)} />
              <YAxis stroke="#94A3B8" tick={{ fill: "#94A3B8", fontSize: 10 }} />
              <Tooltip contentStyle={{ background: "#0A0B10", border: "1px solid #1E293B", borderRadius: 0 }} />
              <Area type="monotone" dataKey="sf" stroke="#00D4FF" fill="url(#cyanFill)" strokeWidth={2} />
              <Area type="monotone" dataKey="hours" stroke="#00BFA5" fill="url(#tealFill)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </section>

      <section className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-[#12141D] border border-border p-5">
          <h3 className="font-heading font-semibold mb-3">Status Breakdown</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
              <PieChart>
                <Pie data={d?.status_breakdown || []} dataKey="value" nameKey="name" outerRadius={90} innerRadius={55}>
                  {(d?.status_breakdown || []).map((s, i) => (
                    <Cell key={i} fill={STATUS_COLOR[s.name] || "#00D4FF"} stroke="#0A0B10" />
                  ))}
                </Pie>
                <Legend wrapperStyle={{ fontSize: 11, color: "#94A3B8" }} />
                <Tooltip contentStyle={{ background: "#0A0B10", border: "1px solid #1E293B", borderRadius: 0 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-[#12141D] border border-border p-5">
          <h3 className="font-heading font-semibold mb-3">Department Output</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
              <PieChart>
                <Pie data={d?.department_breakdown || []} dataKey="value" nameKey="name" outerRadius={90} innerRadius={55}>
                  {(d?.department_breakdown || []).map((_, i) => (
                    <Cell key={i} fill={["#00D4FF","#00BFA5","#0EA5E9","#F59E0B","#10B981"][i % 5]} stroke="#0A0B10" />
                  ))}
                </Pie>
                <Legend wrapperStyle={{ fontSize: 11, color: "#94A3B8" }} />
                <Tooltip contentStyle={{ background: "#0A0B10", border: "1px solid #1E293B", borderRadius: 0 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </section>
    </div>
  );
}
